import { OrganisationHeadingEnum } from "./organisation-heading-enum";
import { OrganisationRoutingConstants } from "../../organisation-settings-routing.constants";
export const OrganisationLinkMap = new Map([
    [OrganisationHeadingEnum.Details, OrganisationRoutingConstants.DETAILS_ROUTE],
    [OrganisationHeadingEnum.Requests, OrganisationRoutingConstants.APPLICATION_ROUTE],
    [OrganisationHeadingEnum.Modules, OrganisationRoutingConstants.MODULES_ROUTE],
    [OrganisationHeadingEnum.Users, OrganisationRoutingConstants.USERS_ROUTE],
    [OrganisationHeadingEnum.NotificationTemplates, OrganisationRoutingConstants.NOTIFICATION_TEMPLATES_ROUTE],
    [OrganisationHeadingEnum.PortalMapService, OrganisationRoutingConstants.AFLA_PORTAL_MAP_SERVICE_ROUTE],
    [OrganisationHeadingEnum.SmsSettings, OrganisationRoutingConstants.ORGANISATION_SMS_SETTINGS_ROUTE],
    [OrganisationHeadingEnum.BackupAndRestore, OrganisationRoutingConstants.ORGANISATION_BACKUP_RESTORE_SETTINGS_ROUTE],
]);
